import React from 'react';
import { Alert, Text } from '@gjensidige/builders-components'

import { useAppDispatch, useAppSelector } from '../hooks/appHooks';
import { updatePlusPacketSelection } from '../store/slices/offerSlice';
import InsurancePackage from '../components/InsurancePackage/InsurancePackage';
import { Package } from '../interfaces/Types';
import { AppConstants } from '../utils/AppConstants';
import { InsuranceHelper } from '../utils/InsuranceHelper';
import { TextHelper } from '../utils/TextHelper';
import { SectionHeader } from '../components/Common/SectionHeader/SectionHeader';

interface PlusPacketProps {
  plusPacketData: Package[];
}
export const PlusPacketContainer: React.FC<any> = (props: PlusPacketProps) => {
  const dispatch = useAppDispatch();

  const updateTileSelection = (selectedTile: any) => {
    if (selectedTile.isEnabled) {
      if (selectedTile.isSelected) {
        dispatch(updatePlusPacketSelection(selectedTile));
      } else {
        // If selecting a new tile, first deselect all other addons
        props.plusPacketData.forEach((packageItem: Package) => {
          if (packageItem.isSelected && packageItem.packageCode !== selectedTile.packageCode) {
            dispatch(updatePlusPacketSelection({
              ...packageItem,
              isSelected: false
            }));
          }
        });
        dispatch(updatePlusPacketSelection(selectedTile));
      }
    }
  };

  const productName = useAppSelector(
    (state) => state.insurance.offer.productName
  );

  const additionalPackageDescription =
    TextHelper.getAdditionalPackageDescription(productName);

  const renderPackageDisabledInfo = (
    disabledMessage: string
  ) => {
    return (
      <div className="mt-2 information-alert">
        <Alert
          severity="informative"
          variant="outlined"
        >
          <Text size="body"
            dangerouslySetInnerHTML={{
              __html: disabledMessage || AppConstants.getAppText('webshop.plusPacket.disableMessage')
            }}
          ></Text>
        </Alert>
      </div>
    );
  };

  const allPackagesDisabledMessage = props.plusPacketData.find((packageItem: Package) => packageItem.disabledMessage)?.disabledMessage ?? AppConstants.getAppText('webshop.plusPacket.disableMessage');
  const isAllPackagesDisabled = !props.plusPacketData.every((packageItem: Package) =>
    InsuranceHelper.shouldDispayPlusPackage(
      productName,
      packageItem)
  )

  const lastAddonIndex = props.plusPacketData.length - 1;

  return (
    <>
      <div className="mt-2 mb-2">
        <SectionHeader
          wrapperClass={`mb-2`}
          headerText={AppConstants.getAppText(
            'webshop.additionalPackage.header'
          )}
        />
        {additionalPackageDescription && (
          <Text size="large">{additionalPackageDescription}</Text>
        )}
      </div>
      {props.plusPacketData.map((packageItem: Package, index: number) => {
        if (!InsuranceHelper.isEmptyObject(packageItem)) {
          const priceHeaderInfo = TextHelper.getPackageHeaderLabels(
            productName,
            packageItem,
            []
          );

          return (
            <div key={index}>
              {InsuranceHelper.shouldDispayPlusPackage(
                productName,
                packageItem
              ) && (
                  <div className={lastAddonIndex === index ? '' : `pb-2`}>
                    <div
                      className={`${!packageItem.isEnabled
                        ? 'disable-pluspacket disabled-tile'
                        : ''
                        }`}
                    >
                      <InsurancePackage
                        updateTileSelection={updateTileSelection}
                        data={packageItem}
                        priceLabel={priceHeaderInfo.priceLabel}
                        oldPriceLabel={priceHeaderInfo.oldPriceLabel}
                        packageTitle={priceHeaderInfo.packageTitle}
                        additionalInfos={priceHeaderInfo.packageInfos}
                      />
                    </div>
                    {!packageItem.isEnabled &&
                      renderPackageDisabledInfo(
                        packageItem.disabledMessage
                      )}
                  </div>
                )}
            </div>
          );
        }
      })}
      {isAllPackagesDisabled &&
        renderPackageDisabledInfo(
          allPackagesDisabledMessage
        )
      }
    </>
  );
};
